// Fonctions utilitaires partagées pour les composants demandeur

export const formatDate = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('fr-FR', { 
    day: '2-digit', 
    month: '2-digit', 
    year: 'numeric'
  });
};

export const calculateAge = (dateString) => {
  if (!dateString) return '';
  const birthDate = new Date(dateString);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  
  return age;
};

export const getLatestExperience = (experiences) => {
  if (!experiences || experiences.length === 0) return null;
  return experiences[0];
};

export const calculateTotalExperienceYears = (experiences) => {
  if (!experiences || experiences.length === 0) return 0;
  
  const totalMonths = experiences.reduce((total, exp) => {
    const startDate = new Date(exp.date_debut);
    const endDate = exp.date_fin ? new Date(exp.date_fin) : new Date();
    const months = (endDate.getFullYear() - startDate.getFullYear()) * 12 + 
                  (endDate.getMonth() - startDate.getMonth());
    return total + months;
  }, 0);
  
  return Math.round(totalMonths / 12 * 10) / 10;
};

export const formatGenre = (genre) => {
  const genres = {
    'monsieur': 'Monsieur',
    'madame': 'Madame',
    'mademoiselle': 'Mademoiselle'
  };
  return genres[genre] || genre;
};
